import { useCallback } from 'react';

import { AxiosError, AxiosResponse } from 'axios';
import { useMutation, UseMutationResult } from 'react-query';
import { Document, ErrorMessage } from 'types';
import { client } from 'utils/api-client';

function useSendDocumentEmail(): UseMutationResult<AxiosResponse<null>, AxiosError<ErrorMessage>, Document> {
  const sendDocument = useCallback((document: Document): Promise<AxiosResponse<null>> => {
    return client.post(`/documents/${document.documentId}/send-document-email/`, {});
  }, []);

  return useMutation(sendDocument);
}

export default useSendDocumentEmail;
